import { EntityStoreName } from 'app/enums/store';
import { AppState } from 'app/interfaces/store';
import { SearchUsersState } from 'modules/users/store/search-users/interfaces/search-users-state';

import { entityAdapter } from 'modules/users/store/users/adapter';

const selectAll = entityAdapter.getSelectors<AppState>(
  (state) => state[EntityStoreName.SearchUsers] as SearchUsersState
).selectAll;

export const searchUsersSelector = {
  all: selectAll,
};
